import ApplicationController from "./application_controller";

export default class extends ApplicationController {

  static targets = [ 'startTime', 'endTime', 'location' ]

  updateEndTime() {
    // add 30 minutes to the start time
    const startTime = this.startTimeTarget.value;
    const endTime = new Date(startTime);
    endTime.setMinutes(endTime.getMinutes() + 60);
    this.endTimeTarget._flatpickr.setDate(endTime);
  }

  updateLocationType() {
    const selected = this.element.querySelector('input[name="meeting[location_type]"]:checked')
    const location = selected ? selected.value : ''
    // Synchron zu Meeting::LOCATION_TYPES_USING_LINK
    if (['msteams', 'zoom', 'jitsi', 'online'].includes(location)) {
      this.locationTarget.value = ''
    }
  }

  setToday(event) {
    event.preventDefault();
    const today = new Date();
    today.setHours(today.getHours() + 1);
    this.startTimeTarget._flatpickr.setDate(today);
    this.updateEndTime();
  }

  setTomorrow(event) {
    event.preventDefault();
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.startTimeTarget._flatpickr.setDate(tomorrow);
    this.updateEndTime();
  }

  setNextWeek(event) {
    event.preventDefault();
    const nextWeek = new Date();
    nextWeek.setDate(nextWeek.getDate() + 7);
    this.startTimeTarget._flatpickr.setDate(nextWeek);
    this.updateEndTime();
  }

  setNextMonth(event) {
    event.preventDefault();
    const nextMonth = new Date();
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    this.startTimeTarget._flatpickr.setDate(nextMonth);
    this.updateEndTime();
  }

}
